module.exports = __webpack_public_path__ + "img/LOGO.b0d628e2.png";